import tdt from "./tianDiTu";

enum MapIdType {
    Osm = 0,
    Google = 1,
    Bing = 2,
    AMap = 3,
    BaiDu = 4,
    TianDiTu = 5,
}


export { MapIdType, tdt};